
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["uploadCloud_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M554.667 550.4V768h192C832 759.467 896 686.933 896 597.333c0-93.866-76.8-170.666-170.667-170.666h-4.266C699.733 328.533 614.4 256 512 256c-119.467 0-213.333 93.867-213.333 213.333-72.534 8.534-128 72.534-128 149.334C170.667 699.733 238.933 768 320 768h192V550.4l-98.133 98.133L384 618.667l149.333-149.334 149.334 149.334-29.867 29.866-98.133-98.133zm0 217.6v42.667H512V768h-64v42.667H320c-106.667 0-192-85.334-192-192 0-85.334 55.467-157.867 128-183.467 17.067-123.733 123.733-221.867 256-221.867 110.933 0 209.067 72.534 243.2 170.667 102.4 12.8 183.467 102.4 183.467 213.333s-85.334 200.534-192 213.334h-128V768h-64z","fill":"#dbdbdb"}})])
          )
        }
      }
    